import React from 'react';

const DefaultFooter = props => {
    const {callback} = props;
    return (
        <footer className="footer cont-footer ch-footer">
            <span className="ftr_byEdj"></span>
        </footer>
    )
}

export default DefaultFooter;